import { Directive, ElementRef, HostListener, OnDestroy, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';

@Directive({
  selector: '[appDateMask]',
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'DD/MM/YYYY'
        },
        display: {
          dateInput: 'DD/MM/YYYY',
          dateA11yLabel: 'DD/MM/YYYY',
          monthYearLabel: 'MMMM/YYYY',
          monthYearA11yLabel: 'MMMM/YYYY',
        }
      }
    }
  ]
})
export class DateMaskDirective implements OnDestroy {

  mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  maskedInputController;

  errors: any;


  constructor(private readonly element: ElementRef, @Optional() private readonly ngControl: NgControl) {
    this.maskedInputController = textMask.maskInput({
      inputElement: this.element.nativeElement,
      mask: this.mask
    });
  }

  ngOnDestroy() {
    this.maskedInputController.destroy();
  }

  @HostListener('keyup')
  onKeyPress() {
    this.validateDatepicker();
  }

  @HostListener('change')
  onBlur() {
    this.validateDatepicker();
  }

  private validateDatepicker() {
    if (!this.errors) {
      this.errors = this.ngControl.errors;
    }

    const value = this.element.nativeElement.value;

    if (this.ngControl && value && value !== '_/__/____' && value !== '' && this.hasDateError()) {
      if (this.hasDatepickerParseError()) {
        this.ngControl.control.setErrors({'matDatepickerParse': true});
      } else if (this.hasDatepickerMinError()) {
        this.ngControl.control.setErrors({'matDatepickerMin': true});
      } else if (this.hasDatepickerMaxError()) {
        this.ngControl.control.setErrors({'matDatepickerMax': true});
      }
    } else if (!this.element.nativeElement.value) {
      if(this.errors && this.errors.required){
        this.ngControl.control.setErrors(this.errors);
        this.ngControl.control.updateValueAndValidity();
      }else{
        this.ngControl.control.setErrors(null);
      }
    }
  }

  private hasDateError() {
    return this.hasDatepickerParseError() || this.hasDatepickerMinError() || this.hasDatepickerMaxError();
  }

  private hasDatepickerMaxError() {
    return this.ngControl.control.hasError('matDatepickerMax');
  }

  private hasDatepickerMinError() {
    return this.ngControl.control.hasError('matDatepickerMin');
  }

  private hasDatepickerParseError() {
    return this.ngControl.control.hasError('matDatepickerParse');
  }
}
